import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=141479a8&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "../assets/css/index-new.css?vue&type=style&index=0&id=141479a8&prod&scoped=true&lang=css&external"
import style1 from "./Index.vue?vue&type=style&index=1&id=141479a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141479a8",
  null
  
)

export default component.exports